module.exports = __webpack_public_path__ + "fonts/PTC55F-webfont.6284204.woff";